import React, { useRef } from 'react'
import { useIsVisible } from '../../hooks/useIsVisible'
import { Link } from 'gatsby'

export default function Footer() {
  const logoRef = useRef<HTMLImageElement>(null)
  const logoIsVisible = useIsVisible(logoRef)

  const contactRef = useRef<HTMLUListElement>(null)
  const contactIsVisible = useIsVisible(contactRef)

  const socialRef = useRef<HTMLUListElement>(null)
  const socialIsVisible = useIsVisible(socialRef)

  const subscribeRef = useRef<HTMLUListElement>(null)
  const subscribeIsVisible = useIsVisible(subscribeRef)

  const legalRef = useRef<HTMLParagraphElement>(null)
  const legalIsVisible = useIsVisible(legalRef)

  return (
    <footer className="bg-black px-16 pt-4 pb-8 text-white font-Myriad_Pro">
      <div className="grid max-sm:block grid-cols-[1.5fr_1fr_1fr] gap-4">
        <div className="col-span-3 row-span-1 py-16">
          <img
            ref={logoRef}
            src="/images/DA_icon.svg"
            alt="Distrito Álamos"
            style={{ width: 180 }}
            className={`transition-all duration-1000 ${logoIsVisible ? 'opacity-100 mt-0 mb-0' : 'opacity-0 -mt-6 mb-6'}`}
          />
        </div>
        <div className="col-span-1 row-span-1 text-lg pb-16">
          <ul
            ref={contactRef}
            className={`list-none transition-all duration-1000 ${contactIsVisible ? 'opacity-100 ml-0' : 'opacity-0 -ml-6'}`}
          >
            <li className="font-serif italic">Corregidora Norte #483</li>
            <li className="font-serif">
              <a href="mailto:Distrito Álamos<informes@distritoalamos.com>">
                informes@distritoalamos.com
              </a>
            </li>
            <li className="font-serif">
              <a href="tel:1234567890">(811) 347 0217</a>
            </li>
            <li>
              <a
                href="https://wa.me/8113470217"
                target="_blank"
                rel="noreferrer"
              >
                Whatsapp
              </a>
            </li>
          </ul>
        </div>
        <div className="col-span-2 row-span-1 text-lg max-sm:pb-12">
          <ul
            ref={socialRef}
            className={`list-none transition-all duration-1000 ${socialIsVisible ? 'opacity-100 ml-0' : 'opacity-0 -ml-6'}`}
          >
            <li>
              <a
                href="https://www.instagram.com/distritoalamos_qro/"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
            </li>
          </ul>
        </div>
        <div className="col-span-1 row-span-1 text-sm max-sm:pb-12">
          <ul
            ref={subscribeRef}
            className={`list-none flex flex-col h-full justify-between transition-all duration-1000 ${subscribeIsVisible ? 'opacity-100 ml-0' : 'opacity-0 -ml-6'}`}
          >
            <li>
              <Link to="/aviso-de-privacidad">Aviso de privacidad</Link>
            </li>
          </ul>
        </div>
        <div className="col-span-2 row-span-1 text-sm text-neutral-400">
          <p
            ref={legalRef}
            className={`list-none transition-all duration-1000 ${legalIsVisible ? 'opacity-100 ml-0 mr-0' : 'opacity-0 -mr-6 ml-6'}`}
          >
            © 2024 Distrito Alamos. The Distrito Alamos trademark and related
            logos are protected under copyright. Images may be representative
            examples of Distrito Alamos and do not necessarily depict the exact
            design. Distrito Alamos reserves the right to make changes to any
            product.
            <br />
            Reference to third party names is for informational purposes only
            and is not necessarily an endorsement or association of Distrito
            Alamos or vice versa.
          </p>
        </div>
      </div>
    </footer>
  )
}
